import React from 'react'

export default function ArrowUpDown({ ...props }) {
  return (
    <svg viewBox="0 0 24 24" {...props} xmlns="http://www.w3.org/2000/svg">
      <path d="M12.05 7.95L17 3L21.9501 7.95L20.535 9.364L18 6.828V20H16V6.828L13.465 9.364L12.05 7.95ZM2.05005 16.05L3.46405 14.636L5.99905 17.172L5.99905 4H7.99905L7.99905 17.172L10.535 14.636L11.95 16.05L7.00005 21L2.05005 16.05Z" />
    </svg>
  )
}
